import { render } from "./FullFramePageContainer.vue?vue&type=template&id=d99e4510&scoped=true"
import script from "./FullFramePageContainer.vue?vue&type=script&lang=js"
export * from "./FullFramePageContainer.vue?vue&type=script&lang=js"

import "./FullFramePageContainer.vue?vue&type=style&index=0&id=d99e4510&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d99e4510"]])

export default __exports__